import React, { useState, useEffect, useCallback } from 'react';
import {
    Typography,
    List,
    ListItem,
    ListItemText,
    Chip,
    CircularProgress,
    Alert,
    Paper,
} from '@mui/material';
import { invitationService } from '../services/invitationService';
import { useSnackbar } from 'notistack';

const InvitationList = ({ eventId }) => {
    const [invitations, setInvitations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { enqueueSnackbar } = useSnackbar();

    const fetchInvitations = useCallback(async () => {
        try {
            const response = await invitationService.getInvitationsByEventId(eventId);
            setInvitations(Array.isArray(response.data) ? response.data : []);
        } catch (error) {
            setError('Failed to load invitations');
            enqueueSnackbar('Failed to load invitations', { variant: 'error' });
        } finally {
            setLoading(false);
        }
    }, [eventId, enqueueSnackbar]);

    useEffect(() => {
        fetchInvitations();
    }, [fetchInvitations]);

    if (loading) {
        return <CircularProgress />;
    }

    if (error) {
        return <Alert severity="error">{error}</Alert>;
    }

    return (
        <Paper elevation={3} sx={{ p: 4, mt: 3 }}>
            <Typography variant="h6" gutterBottom>
                Invitations
            </Typography>
            {invitations.length === 0 ? (
                <Typography variant="body2" color="text.disabled">
                    No invitations sent yet.
                </Typography>
            ) : (
                <List disablePadding>
                    {invitations.map((invitation) => (
                        <ListItem key={invitation.id} disableGutters>
                            <ListItemText
                                primary={invitation.email}
                                secondary={`Sent ${new Date(invitation.createdAt).toLocaleDateString()}`}
                            />
                            <Chip
                                label={invitation.status}
                                size="small"
                                color={
                                    invitation.status === 'ACCEPTED'
                                        ? 'success'
                                        : invitation.status === 'DECLINED'
                                        ? 'error'
                                        : 'default'
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            )}
        </Paper>
    );
};

export default InvitationList; 